import React from "react";
import { WORLD_OSHAR_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import OsharHero from "../../components/oshar/OsharHero";
import OsharIntro from "../../components/oshar/OsharIntro";
import OsharFeatureGrid from "../../components/oshar/OsharFeatureGrid";
import OsharDistricts from "../../components/oshar/OsharDistricts";
import OsharRealEstateCTA from "../../components/oshar/OsharRealEstateCTA";
import "./oshar-page.css";

const WorldOsharPage = () => {
  usePageSeo(WORLD_OSHAR_SEO);

  return (
    <div className="oshar-page">
      <main>
        <OsharHero />
        <OsharIntro />
        <OsharFeatureGrid />
        <OsharDistricts />
        <OsharRealEstateCTA />
      </main>
    </div>
  );
};

export default WorldOsharPage;
